import React, {PropTypes} from "react";
import {connect} from "react-redux";
import Button from "react-bootstrap/lib/Button";
import LinearProgress from "material-ui/LinearProgress";
import TeamSearch from "./TeamSearch";
import Dialog from "material-ui/Dialog";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import EmployeeTable from "./EmployeeTable";
import TeamInfoSummary from "./TeamInfoSummary";
import * as actions from "../../../redux/actions/Attendance/attendanceActions";
import csvConvert from '../../../classes/csvConvert';
import axios from "axios";
const style = {
  height: 200,
  width: 300,
  margin: 20,
  textAlign: 'center',
  display: 'inline-block',
};
let from = new Date();
from.setDate(from.getDate() - 7);
let to = new Date();
var default_search = {
  startDate: from,
  endDate: to
};
class MyTeamAttendance extends React.Component {

  constructor() {
    super();
    this.state = {
      functionHead: false,
      indirect: false,
      vertical: false,
      requestObject: null,
      value: 1,
      flag: true,
      actual: true,
      average: true,
      showAll: 0,
      show: false,
      pageNo: 0,
      empId: -1,
      empName: "",
      attPageNo: 0,
      selectId: -1,
      isVertical: false

    };
    this.changePageNo = this.changePageNo.bind(this);
    this.handleSelect = this.handleSelect.bind(this);

    this.toggleDetails = this.toggleDetails.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.formSubmit = this.formSubmit.bind(this);
    this.viewDetails = this.viewDetails.bind(this);
    this.changeEmp = this.changeEmp.bind(this);
    this.changeDirect = this.changeDirect.bind(this);
    this.changeAttPage = this.changeAttPage.bind(this);
    this.download_excel = this.download_excel.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.changeFunctionHead = this.changeFunctionHead.bind(this);
    this.changeView = this.changeView.bind(this);
  }

  changePageNo(increase, decrease) {
    if (increase)
      this.setState({pageNo: this.state.pageNo + 1});
    else if (decrease)
      this.setState({pageNo: this.state.pageNo - 1});
  }

  changeDirect() {
    if (!this.state.indirect)
      this.setState({indirect: !this.state.indirect, functionHead: false, vertical: false});
    else this.setState({indirect: !this.state.indirect})

  }

  changeView() {
    if(!this.state.vertical)
      this.setState({vertical: !this.state.vertical, functionHead: false, indirect: false});
    else this.setState({vertical: !this.state.vertical})

  }

  changeFunctionHead() {
    if (!this.state.functionHead && this.state.indirect)
      this.setState({functionHead: !this.state.functionHead, indirect: false});
    else
      this.setState({functionHead: !this.state.functionHead});
  }

  handleSelect(selectedKey) {
    if (selectedKey != this.state.value)
      this.setState({value: selectedKey, flag: !this.state.flag});
  }

  viewDetails(request) {
    console.log(this.props.teamDates);
    request.startDate = this.props.teamDates.startDate;
    request.endDate = this.props.teamDates.endDate;

    this.props.dispatch(actions.getTeamDetails(request, 0));

    this.setState({show: !this.state.show, attPageNo: 0, selectId: request.empId, empName: request.name})

    console.log(request);
  }

  changeAttPage(pageNo) {
    console.log(this.props.teamDates);
    console.log(this.state.empId);
    console.log(pageNo);
    let request = new Object();
    request.startDate = this.props.teamDates.startDate;
    request.endDate = this.props.teamDates.endDate;
    request.empId = this.state.selectId;

    this.props.dispatch(actions.getTeamDetails(request, pageNo));
    this.setState({attPageNo: pageNo});
  }

  onSelect(event, index, value) {
    this.setState({showAll: value});
  }

  toggleDetails() {
    this.setState({actual: !this.state.actual});
  }


  formSubmit(request, refresh) {

    this.setState({pageNo: 0});
    request.empId = this.state.empId;
    request.pageNo = 0;
    request.indirect = this.state.indirect;
    request.vertical = this.state.vertical;
    request.functionHead = this.state.functionHead;
    this.setState({requestObject: request});
    console.log(this.state.empId);

    this.props.changeTeamPage(0, null);
    this.props.dispatch(actions.getTeamAttendance(request))
  }

  download_excel() {

    let request = new Object();

    request.empId = this.state.empId;
    request.pageNo = 0;
    request.indirect = this.state.indirect;
    request.vertical = this.state.vertical;
    request.function = this.state.functionHead;
    request.from = this.props.teamDates.startDate;
    request.to = this.props.teamDates.endDate;
    console.log(this.state.empId);
    if (request.empId == -1)
      request.empId = null;
    console.log("hell yeah");
    console.log(request);
    axios.get(process.env.REQ_URL + '/attendance/download/_search?q=' + JSON.stringify(request), {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {

      console.log(response);
      let data = response.data.data;
      let csv = new csvConvert();
      var csvContent = csv.convertArrayOfAnyObjectsToCSV({data: data});
      let blob = new Blob([csvContent], {type: "text/csv;charset=utf-8;"});
      blob = window.URL.createObjectURL(blob);
      let getCsv = new Promise((resolve, reject)=> {
        this.setState({csv: blob})
        resolve(true);
      });
      getCsv.then((response)=> {
        this.download.click();
      })
    }).catch((error) => {
      console.log(error);
    });

    /*
     let data=response.data.data;
     var csvContent = "data:text/csv;charset=utf-8,";
     data.forEach(function(infoArray, index){

     let dataString = infoArray.join(",");
     csvContent += index < data.length ? dataString+ "\n" : dataString;

     });
     var encodedUri = encodeURI(csvContent);*/
    // window.open(encodedUri);

    // this.props.dispatch(actions.getTeamAttendance(request))

  }

  renderShowsTotal(start, to, total) {
    return (
      <p style={ {color: 'black'} }>
        From { start } to { to }, total entries { total }
      </p>
    );
  }


  changeEmp(id) {
    this.setState({empId: id});
  }

  componentDidMount() {
      this.setState({isVertical: this.props.isVertical});
  }

  handleClose() {
    this.setState({show: false})
  }

  render() {
    const action = [
      <Button disabled={this.state.attPageNo > 0 ? false : true}
              style={{marginRight: '50'}}
              onClick={()=> {

                this.changeAttPage(this.state.attPageNo - 1);
                this.setState({attPageNo: this.state.attPageNo - 1});
              }}

      >Previous</Button>,

      <Button disabled={this.props.details.length >= 25 ? false : true}
              style={{marginRight: '35%'}}
              onClick={()=> {

                this.changeAttPage(this.state.attPageNo + 1);
                this.setState({attPageNo: this.state.attPageNo + 1});
              }}
      >Next</Button>,
      <Button
        backgroundColor={'#428BCA'}
        onTouchTap={()=> {
          this.setState({show: !this.state.show})
        }
        }
      >Go Back</Button>

    ];
    const stylePaperInfo = {
      height: "100%",
      width: "100%",

      marginRight: '0%',

      marginLeft: '0',
      marginTop: '0%',
      textAlign: 'left',
      display: 'inline-block',
      borderBottomStyle: 'solid',
      borderWidth: '1px',
      borderColor: '#008bcf'
    };
    const stylePaperInfoTable = {
      height: "100%",
      width: "100%",
      borderBottomStyle: 'solid',
      borderWidth: '1px',
      borderColor: '#008bcf',

      marginRight: '5%',

      marginLeft: '0',
      marginTop: '0%',
      textAlign: 'left',
      display: 'inline-block',


    };

    console.log("h p hip");
    let teamDetails = {};

    console.log(this.props.state[2]);
    let attendanceTeam = this.props.state[2];
    let length = this.props.state[2].attendanceTeam.attendanceTeam.length;
    if (this.state.selectId != -1) {
      teamDetails = this.props.state[2].attendanceTeam.attendanceTeam.filter((node)=> {
        if (node.empId == this.state.selectId)
          return true;
      })
    }

    return (
      <div>
        <div>
          <div role="tabpanel" className="tab-pane" id="apply">
            <div className="row clearfix">

              <div className="col-md-12" style={{paddingLeft: '0'}}>
                <div style={stylePaperInfo}>
                  <TeamSearch
                    employeeCode={this.props.employee[0].empno}

                    downloadExcel={this.download_excel}
                    changeDirect={this.changeDirect}
                    changeView={this.changeView}
                    changeFunctionHead={this.changeFunctionHead}
                    indirect={this.state.indirect}
                    vertical={this.state.vertical}
                    functionHead={this.state.functionHead}
                    isVertical={this.state.isVertical}
                    formSubmit={this.formSubmit}
                    changeDate={this.props.changeTeamDate}
                    dates={this.props.teamDates}
                    toggleSearch={this.toggleDetails}
                    employees={attendanceTeam.attendanceTeam.attendanceTeam}
                    choice={this.state.showAll}
                    empId={this.state.empId}
                    changeEmp={this.changeEmp}
                    onSelect={this.onSelect}/>
                </div>
                <a href={this.state.csv} download={"teamAttendance.csv"}
                   ref={(input) => {
                     this.download = input;
                   }}/>

                {this.props.loading > 0 ?
                  <LinearProgress mode="indeterminate" style={{marginLeft: '0%', width: '100%'}}/> : <label></label> }
                <div style={stylePaperInfoTable}>
                  <BootstrapTable data={attendanceTeam.attendanceTeam.attendanceTeam}
                                  trClassName="rowX"

                                  height="350"
                                  exportCSV={true}

                                  tableStyle={{paddingTop: 0, margin: 0}}
                                  striped={false} hover={true}
                                  condensed={true}>
                    <TableHeaderColumn dataSort={true}
                                       columnClassName="rowX"
                                       isKey={true} width={100} dataField="empId">Emp Id</TableHeaderColumn>
                    <TableHeaderColumn columnClassName="rowX"
                                       filter={ {type: 'TextFilter', delay: 0, placeholder: 'Name'} }
                                       dataSort={true} width={200}
                                       dataField="name" >Employee<br/>Name</TableHeaderColumn>
                    <TableHeaderColumn
                      columnClassName="rowX"
                      dataSort={true} width={100} dataField="avgInTime">Avg<br/>In Time</TableHeaderColumn>

                    <TableHeaderColumn columnClassName="rowX"
                                       dataSort={true} width={100} dataField="avgOutTime">Avg<br/>Out
                      Time</TableHeaderColumn>
                    <TableHeaderColumn columnClassName="rowX" dataSort={true} width={100}
                                       dataField="avgWorkHours">Avg<br/>Work Hrs</TableHeaderColumn>
                    <TableHeaderColumn columnClassName="rowX" dataSort={true} width={80} dataField="regularizedCount">Regularized<br/>
                      Count</TableHeaderColumn>
                    <TableHeaderColumn columnClassName="rowX" dataSort={true} width={200} dataField="reportingManager">Reporting<br/>Manager</TableHeaderColumn>
                    <TableHeaderColumn columnClassName="rowX" dataField="" width={80}
                                       dataFormat={(cell, row, formatExtraData, rowIdx)=> {
                                         return <a
                                           style={{padding: 5, width: '100%'}}
                                           onClick={()=> {
                                             this.viewDetails({name: row.name, empId: row.empId})
                                           }}>View</a>
                                       }
                                       }>View <br/>More</TableHeaderColumn>
                  </BootstrapTable>
                </div>


                <div className = "hidden" style={{padding: '0px'}}>
                  <div className="col-md-4" style={{marginLeft: '10%'}}></div>
                  <Button
                    disabled={this.props.teamPageNo > 0 ? false : true}
                    style={{marginRight: '10px'}}
                    onClick={()=> {

                      let request = new Object();
                      request.startDate = this.props.teamDates.startDate;
                      request.endDate = this.props.teamDates.endDate;
                      request.pageNo = this.props.teamPageNo - 1;
                      request.empId = null;
                      request.indirect = this.state.indirect;
                      request.functionHead = this.state.functionHead;
                      request.vertical = this.state.vertical;
                      this.props.changeTeamPage(this.props.teamPageNo - 1, request);
                      this.props.dispatch(actions.getTeamAttendance(request));


                    }
                    }
                  >
                    Previous</Button>
                  <Button
                    style={{align: 'right', marginLeft: '10px'}}
                    disabled={length < 25 ? true : ((this.state.showAll == 0) ? false : true) }
                    onClick={()=> {

                      let request = new Object();
                      request.startDate = this.props.teamDates.startDate;
                      request.endDate = this.props.teamDates.endDate;
                      request.pageNo = this.props.teamPageNo + 1;
                      request.empId = null;
                      request.functionHead = this.state.functionHead;
                      request.indirect = this.state.indirect;
                      request.vertical = this.state.vertical;
                      this.props.changeTeamPage(this.props.teamPageNo + 1, request);
                      this.props.dispatch(actions.getTeamAttendance(request));
                    }
                    }>
                    Next</Button>
                </div>
              </div>
            </div>
            <div>
              <Dialog
                title={"" + this.state.selectId + " " + this.state.empName + " (" + this.props.teamDates.startDate.toString().substr(0, 11) + " - " + this.props.teamDates.endDate.toString().substr(0, 11) + ")"}
                autoScrollBodyContent={true}
                autoDetectWindowHeight={true}
                contentStyle={{
                  borderBottomStyle: 'solid',
                  borderWidth: '1px',
                  borderColor: '#008bcf',
                  height: '100%', width: '80%', maxWidth: 'none'
                }}
                bodyStyle={{
                  borderStyle: 'solid',
                  borderWidth: '2px',
                  borderColor: '#008bcf',
                }}
                actionsContainerStyle={{padding: '10px', marginRight: '0%'}}
                actions={action}
                modal={false}
                onRequestClose={this.handleClose}
                open={this.state.show}
              >
                <div style={{height: '100%'}}>
                  <div className="col-md-12" style={{display: 'block'}}>
                    <TeamInfoSummary attendanceMain={teamDetails[0]}/>
                  </div>
                  <br/><br/><br/>

                  <div style={{display: 'block'}} className="col-md-12">
                    <EmployeeTable attendanceDetails={{attendance: this.props.details}}/>
                  </div>
                </div>
              </Dialog></div>
          </div>
        </div>

      </div>
    );
  }
}

MyTeamAttendance.propTypes = {};

function mapStateToProps(state, ownState) {
  return {
    state: state.attendance,
    employee: state.emp,
    regState: state.attendance[3],
    details: state.attendance[4],
    loading: state.ajaxCallsInProgress
  };

}


export default connect(mapStateToProps)(MyTeamAttendance);




/** WEBPACK FOOTER **
 ** ./src/feature/attendance/TeamAttendance/TeamAttendance.js
 **/